import "./FixedNavBar.scss"
import AuthService from "@model/AuthService";
import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ConfigContext } from "../../../contexts/ConfigContext";
import { Tooltip, Row, Col, Button, } from 'react-bootstrap';
import { IActivityTimes, ICategory, IGood, ICustomerOrder, IOrderDetails, ISampleComment } from "@model/model";
import Api from "@model/Api";

const FixedNavBar = () => {


    const [dateF, setDateF] = useState();
    const [dateE, setDateE] = useState();
    const [showBanner, setShowBanner] = useState(true);
    const [isOpen, setIsOpen] = useState()
    const [userLogin, setUserLogin] = useState();
    const configContext = useContext(ConfigContext);
    const { dispatch } = configContext;
    const {
        openLoginForm,
    } = configContext.state;

    useEffect(() => {
        new Api()
            .get("/api/website/activeTimes")
            .then(async (response) => {
                const { isActive, activeTimes } = await response.json();
                if (response.status == 200) {
                    if (isActive) {
                        setIsOpen(true)
                        setDateF(activeTimes.map(a => a.firstTime))
                        setDateE(activeTimes.map(a => a.endTime))
                    } else {
                        setIsOpen(false)
                        setDateF(activeTimes.map(a => a.firstTime))
                        setDateE(activeTimes.map(a => a.endTime))
                    }
                } else {
                    return null;
                }
            })
            .catch((e) => {
                return null;
            });
    }, [])

    useEffect(() => {
        const profile = new AuthService().getProfile();
        if (profile)
            setUserLogin(profile);
        else {
            setUserLogin(null);
            localStorage.clear();
        }
    }, [configContext]);

    useEffect(() => {
        setTimeout(() => {
            setShowBanner(false)
        }, 5000);
    }, []);




    return (
        <>
            {showBanner ?
                <Row className="banner p-2">
                    <div className="f-2">
                        {isOpen ? ` رستوران در این ساعت باز است ` : " رستوران در این ساعت بسته است."}
                        {" "} ساعت کاری رستوران مابین{" "}
                        <br />
                        {dateF ? new Date(dateF).getHours() + ":" + new Date(dateF).getMinutes() : ""}
                        {" "}تا {" "}
                        {dateE ? new Date(dateE).getHours() + ":" + new Date(dateE).getMinutes() : ""}
                        {" "}می باشد.{" "}
                    </div>
                </Row>
                : <></>}

            <Row className="">
                <div className="mobile-bottom-nav">


                    <Col md={4} className="mobile-bottom-nav__item">
                        {(userLogin && userLogin.userId) ? (
                            <div className="user-exit-edit-nav">
                                <span className="user-name-field">
                                    <span className="hid-in-mobile">نام کاربری:{" "} </span>
                                    <span className="user-name">{userLogin.fullName} </span>
                                </span>
                                <div className="exit-edit">
                                    <Link to="#" onClick={() => { localStorage.clear(); window.location.href = "/"; }} className="exit">
                                        {" "}خروج
                                    </Link>
                                    <span className="space"> | </span>
                                    <Link to="/editUserInfo" className="edit">
                                        {" "}ویرایش
                                    </Link>
                                </div>
                            </div>
                        ) : (
                            <div className="user-login-mobile-nav">
                                <div className="mobile-bottom-nav__item-content" style={{ gap: "5px" }}
                                    onClick={() => {
                                        dispatch({
                                            type: "LOGIN",
                                            openLoginForm: true,
                                        })
                                    }}
                                >
                                    <i className="far fa-user fa-lg"></i>
                                    <p className="f-1">پروفایل</p>

                                </div>
                            </div>

                        )}
                    </Col>
                    <Col md={4} className="mobile-bottom-nav__item">
                        {(userLogin && userLogin.userId) ? (<Link
                            to={"#/ordersList"}
                        >
                            <div className="mobile-bottom-nav__item-content" style={{ gap: "5px" }}>
                                <i className="fas fa-clipboard-list fa-lg"></i>
                                <p className="f-1">سفارش من</p>
                            </div>
                        </Link>) : (
                            <div className="user-login-mobile-nav"
                                onClick={() => {
                                    dispatch({
                                        type: "LOGIN",
                                        openLoginForm: true,
                                    })
                                }}
                            >
                                <div className="mobile-bottom-nav__item-content" style={{ gap: "5px" }}>
                                    <i className="fas fa-clipboard-list fa-lg"></i>
                                    <p className="f-1">سفارش من</p>
                                </div>
                            </div>

                        )}

                    </Col>
                    <Col md={4} className="mobile-bottom-nav__item">
                        <Link
                            to={`/foodorder`}
                            className=""
                        >
                            <div className="mobile-bottom-nav__item-content" style={{ gap: "5px" }}>
                                <i className="far fa-plus-square fa-lg"></i>
                                <p className="f-1">سفارش غذا</p>
                            </div>

                        </Link>
                    </Col>
                </div> </Row>
        </>
    )
}

export default FixedNavBar